var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ueditor-wrap',{attrs:{"config":_vm.config},model:{value:(_vm.contents),callback:function ($$v) {_vm.contents=$$v},expression:"contents"}})
}
var staticRenderFns = []

export { render, staticRenderFns }